import React from 'react';
import { Link } from 'react-router-dom';
import { truncateWords } from '../utils/truncateWords';

function NoteCard({ note, asLink = true, variant = 'carousel' }) {
  const excerpt = truncateWords(note.excerpt, 20);
  const categories = note.categories.slice(0, 2);
  const cardClass =
    variant === 'notes-page'
      ? 'note-card note-card--notes-page'
      : 'note-card';

  const inner = (
    <>
      <h3 className="note-card__title">{note.title}</h3>
      {categories.length > 0 && (
        <div className="note-card__categories">
          {categories.map((category) => (
            <span key={category} className="note-card__category">
              {category}
            </span>
          ))}
        </div>
      )}
      <p className="note-card__excerpt">{excerpt}</p>
    </>
  );

  if (asLink) {
    return (
      <Link to={`/notes/${note.slug}`} className={cardClass}>
        {inner}
      </Link>
    );
  }

  return (
    <article className={`${cardClass} note-card--static`}>{inner}</article>
  );
}

export default NoteCard;
